import { Component, OnInit } from "@angular/core";

@Component({
  selector: "ngx-redirect",
  template: ``,
})
export class RedirectComponent implements OnInit {
  // created this component to fix the error "Layout not found" after login
  constructor() {}

  ngOnInit(): void {
    window.location.href = "/pages";
  }
}
